<template>
  <ontick-div :class="[!noBackground ? 'shadow' : '', 'col-span-12']">
    <table
      :class="[
        !noBackground ? 'bg-ontick-graphite-500' : '',
        head ? ' w-full' : '',
        fixed ? 'table-fixed' : 'table-auto',
        'divide-ontick-graphite-700 min-w-full divide-y-2 overflow-x-auto overflow-y-hidden rounded-lg ',
      ]"
    >
      <thead>
        <slot name="head"></slot>
      </thead>
      <tbody
        name="fruit-table"
        is="transition-group"
        class="divide-ontick-graphite-700 divide-y"
      >
        <slot name="body"></slot>
      </tbody>
    </table>
  </ontick-div>
</template>

<script>
export default {
  name: "ontick-table",
  props: {
    noBackground: {
      type: Boolean,
      default: false,
      validator: function (value) {
        return [true, false].indexOf(value) !== -1;
      },
    },
    head: {
      type: Boolean,
      default: true,
    },
    fixed: { type: Boolean, default: false },
  },
  data() {
    return {
      headClass:
        "px-6 py-4 bg-ontick-graphite-500 text-left text-xs leading-4 font-bold text-ontick-table-head uppercase tracking-wider",
    };
  },
};
</script>

<style lang="scss" scoped>
// table::-webkit-scrollbar {
//   background-color: #171e27;
//   width: 6px;
//   height: 5px;
// }
// table::-webkit-scrollbar-thumb {
//   /*Your styles here*/
//   background-color: slategray !important;
//   width: 6px;
//   height: 5px;
// }
// table::-webkit-scrollbar-thumb:window-inactive {
//   background-color: slategray !important;
//   border-radius: 10px;
// }
table,
td,
th {
  border-collapse: collapse;
}

.fruit-list-move {
  transition: transform 1s;
}
.fruit-table-move {
  transition: transform 1s;
}
</style>
